









































import {Component, Prop, Vue} from 'vue-property-decorator'
import {debounce} from 'lodash'
import VueMultiselect from 'vue-multiselect/src/Multiselect.vue'
import AutoCompleteDestinatario from '@/model/resource/AutoCompleteDestinatario'
import {WholeCollection} from 'simpli-web-sdk'
import * as Helper from '@/helpers'

@Component({components: {VueMultiselect}})
export default class SearchDestinatario extends Vue {
  @Prop({type: [Array, Object]}) value!: AutoCompleteDestinatario | AutoCompleteDestinatario[] | null

  collection = new WholeCollection(AutoCompleteDestinatario)

  @Prop({type: String, default: null})
  label!: string | null

  @Prop({type: String, default: null})
  name!: string | null

  @Prop({type: String, default: null})
  inputClass!: string | null

  @Prop({type: Boolean, default: false})
  required!: boolean

  @Prop({type: Boolean, default: false})
  disabled!: boolean

  @Prop({type: String, default: ''})
  placeholder!: string

  @Prop({type: String, default: null})
  noResultLabel!: string | null

  @Prop({type: String, default: null})
  noOptionsLabel!: string | null

  @Prop({default: null})
  validation!: any

  @Prop({type: Boolean, default: true})
  cleanable!: boolean

  @Prop({type: Boolean, default: false})
  multiple!: boolean

  @Prop({type: Boolean, default: false})
  showLabels!: boolean

  readonly DEBOUNCE_TIMER = 500
  debouncedFind = debounce(
      async (search: string) => {
        await this.find(search)
      },
      this.DEBOUNCE_TIMER,
  )

  isLoading = false

  get uid() {
    return Helper.uid()
  }

  get computedModel() {
    return this.value
  }

  set computedModel(val: AutoCompleteDestinatario | AutoCompleteDestinatario[] | null) {
    this.$emit('input', val)
  }

  get computedName() {
    return this.name || this.label || '-'
  }

  mounted() {
    this.collection.nullableItems()
  }

  get isCleanable() {
    return (
        this.cleanable &&
        this.computedModel &&
        (this.computedModel as AutoCompleteDestinatario[]).length !== 0
    )
  }

  async find(search: string) {
    if (search.length > 2) {
      this.isLoading = true
      const item = new AutoCompleteDestinatario()
      item.nome = search
      this.collection.items.push(item)
      this.computedModel = item
      await this.collection.query({query: search})
      this.isLoading = false
    }
  }

  customLabel(destinatario: AutoCompleteDestinatario) {
    return destinatario.$tag
  }

  addTagEvent(val: string) {
    this.$emit('tag', val)
  }
}
